import { render, staticRenderFns } from "./InstructorDetails.vue?vue&type=template&id=0f1e557a"
import script from "./InstructorDetails.vue?vue&type=script&lang=js"
export * from "./InstructorDetails.vue?vue&type=script&lang=js"
import style0 from "./InstructorDetails.vue?vue&type=style&index=0&id=0f1e557a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports